import { useTranslate } from "@obsbot/remo-i18n";
import { IServiceTextChat } from "@obsbot/remo-services";
import { Button, Popover, Image } from "antd";
import { Message } from "@tencentcloud/chat";
import React, { useMemo, useState } from "react";
import { CustomModal } from "../../CustomModal";
import lineSVG from "../icons/line.svg";
// import msgSVG from "../icons/msg.svg";
import moreSVG from "../icons/more-horizontal.svg";
import { useChannelRoomStore, useGlobalStore } from "@obsbot/remo-stores";
import { useParams } from "react-router-dom";
import { reactionEmoji } from "@obsbot/remo-server-api";
import EmojiPicker from "../ChatSendInput/EmojiPicker";
import { eventBus } from "@obsbot/remo-utils";
import { ReferenceIcon } from "../../SvgIconCom/ChatContentIcon";
interface HoverMenuProps {
    // commonEmojis: string[];
    onReferenceMessage: (msgID: string) => void;
    msg: Message;
    rtm: IServiceTextChat;
    updateMsgList: (msg: Message) => void;
}
export const HoverMenu: React.FC<HoverMenuProps> = ({
    msg,
    onReferenceMessage,
    rtm,
    updateMsgList,
}) => {
    const t = useTranslate();
    const { userInfo } = useGlobalStore();
    const params = useParams();
    const [showDelete, setShowDelete] = useState(false);
    const { blockedUsers } = useChannelRoomStore();
    const commonEmojis = ["👍🏻", "👏", "🎉"];

    const isBlocked = useMemo(() => {
        return Boolean(params.id && blockedUsers.includes(params.id));
    }, [params.id, blockedUsers]);

    const deleteMsg = async (): Promise<void> => {
        // 删除消息
        const res = await rtm?.deleteMsg(msg);
        if (res) {
            updateMsgList(msg);
            setShowDelete(false);
        } else {
            eventBus.emit("show-message", {
                type: "error",
                message: t("chat.delete-msg-fail"),
            });
        }
    };

    const handleReaction = async (reaction: string): Promise<void> => {
        // updateMessageReaction(msg.ID, reaction, userInfo.user_id, userInfo.nickname);
        if (userInfo && params.id) {
            await reactionEmoji({
                type: "C2C",
                receiverId: params.id,
                senderId: userInfo.user_id, // TODO: add userInfo.user_id
                messageId: msg.ID,
                emojiCode: reaction,
            });
        }
    };

    const selectEmoji = (emoji: string): void => {
        if (userInfo && params.id) {
            reactionEmoji({
                type: "C2C",
                receiverId: params.id,
                senderId: userInfo.user_id, // TODO: add userInfo.user_id
                messageId: msg.ID,
                emojiCode: emoji,
            });
        }
    };

    const footer = (
        <div className="modal-button-group">
            <div className="modal-button-item button-normal" onClick={() => setShowDelete(false)}>
                {t("cancel")}
            </div>
            <div className="modal-button-item button-danger" onClick={deleteMsg}>
                {t("delete")}
            </div>
        </div>
    );
    return (
        <div className="hover-menu-content">
            <CustomModal
                className="delete-modal"
                footer={footer}
                open={showDelete}
                renderHeader={t("chat.delete-msg")}
                setVisible={setShowDelete}
            >
                <div className="delete-modal-content">{t("chat.delete-msg-confirm")}</div>
            </CustomModal>
            {commonEmojis.map((_, i) => {
                return (
                    <Button
                        key={i}
                        disabled={isBlocked}
                        type="text"
                        onClick={handleReaction.bind(this, commonEmojis[i])}
                    >
                        {commonEmojis[i]}
                    </Button>
                );
            })}
            <Button icon={<Image preview={false} src={lineSVG} />} type="text"></Button>
            <Button
                disabled={isBlocked}
                icon={<ReferenceIcon color="#fff" />}
                type="text"
                onClick={() => {
                    onReferenceMessage && onReferenceMessage(msg.ID);
                }}
            ></Button>
            <Popover
                arrow={false}
                classNames={{
                    body: "more-inner-content",
                }}
                content={
                    <div className="msg-hover-menu">
                        {isBlocked ? (
                            <Button disabled type="text">
                                {t("chat.more-emotion")}
                            </Button>
                        ) : (
                            <Popover
                                arrow={false}
                                classNames={{
                                    body: "emoji-content",
                                }}
                                content={<EmojiPicker onSelectEmoji={selectEmoji} />}
                                getPopupContainer={() =>
                                    document.getElementById(msg.ID) as HTMLElement
                                }
                                placement="left"
                            >
                                <Button type="text">{t("chat.more-emotion")}</Button>
                            </Popover>
                        )}
                        <Button danger type="text" onClick={() => setShowDelete(true)}>
                            {t("chat.delete-msg")}
                        </Button>
                    </div>
                }
                placement="top"
                trigger={["hover"]}
            >
                <Button icon={<Image preview={false} src={moreSVG} />} type="text"></Button>
            </Popover>
        </div>
    );
};
